import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RootState } from 'store/rootReducer';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { productsPrefix } from 'routes/routes';
import { getProductFormApiErrors } from 'features/ProductDetails/productForm';
import { tabs, setTab, DETAILS } from './productFormTabs';

const ProductDetailsTabs = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { productId } = useParams<{ productId: string }>();
  const value = useSelector((state: RootState) => state.productFormTabs.currentTab);
  const { loadingError: productsLoadingError } = useSelector(getProductFormApiErrors);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    dispatch(setTab(newValue));
    history.push(`${productsPrefix}/${productId}/${tabs[newValue]}`);
  };

  useEffect(() => {
    if (!isEmpty(productsLoadingError)) {
      dispatch(setTab(0));
      history.push(`${productsPrefix}/${productId}/${DETAILS}`);
    }
  }, [productsLoadingError]);

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      TabIndicatorProps={{ style: { backgroundColor: 'white' } }}
      scrollButtons="auto"
      variant="scrollable"
    >
      <Tab label={t('products.details')} disabled={!productId || !isEmpty(productsLoadingError)} />
      <Tab label={t('products.properties')} disabled={!productId || !isEmpty(productsLoadingError)} />
      {/*<Tab label={t('products.production')} disabled={!productId || !isEmpty(productsLoadingError)} />*/}
      <Tab label={t('products.serial numbers')} disabled={!productId || !isEmpty(productsLoadingError)} />
      {/* <Tab label={t('products.components')} disabled={!productId || !isEmpty(productsLoadingError)} /> */}
      <Tab label={t('products.documents')} disabled={!productId || !isEmpty(productsLoadingError)} />
    </Tabs>
  );
};

export { ProductDetailsTabs };
